import { Button as e, Menu as t } from "@systemeio/components";
import { twJoin as n } from "tailwind-merge";
import { jsx as r } from "react/jsx-runtime";
import { DotsHorizontalIcon as i } from "@systemeio/icons";
//#region src/components/action-menu/index.tsx
function a({ ariaLabel: a, children: o, dataTestAttributes: s, isFetching: c, menuItems: l }) {
	let u = o == null ? /* @__PURE__ */ r(e, {
		...s,
		"aria-label": a,
		disabled: c,
		className: n("data-popup-open:bg-button-secondary-pressed", c && "animate-pulse"),
		variant: "secondary",
		size: "icon-xs",
		children: /* @__PURE__ */ r(i, {})
	}) : typeof o == "function" ? (({ open: e }) => o({ open: e })) : o;
	return /* @__PURE__ */ r(t, {
		disabled: c,
		trigger: u,
		triggerProps: o == null ? void 0 : { "aria-label": a },
		items: l.flatMap((e) => {
			if (!e) return [];
			if (!("onClick" in e)) return e;
			let { dataTestAttributes: t, onClick: n, ...r } = e;
			return {
				...r,
				dataAttributes: t,
				onSelect: n
			};
		})
	});
}
//#endregion
export { a as ActionMenu };
